<template>
  <div>
    <v-dialog
      max-width="550px"
      max-height="550px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Day Off
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row v-if="currentDayOff">
            <v-col cols="12" md="6" lg="6">
              <h3>Date of Day Off</h3>
              <DatePicker
                v-model="currentDayOff.EventDate"
              />
            </v-col>
            <v-col cols="12" md="6" lg="6">
              <h3>Description</h3>
              <v-text-field
                v-model="currentDayOff.EventDescription"
                :rules="[rules.englishOnly]"
                @input="validateDescription"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary"
            @click.prevent="saveDayOff"
            :disabled="disableSave || hasCyrillic"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'DaysOffEditor',
  components: {
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false
    },
    currentDayOff: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      disableSave: false,
      hasCyrillic: false,
      rules: {
        englishOnly: value => {
          if (!value) return true
          const hasCyrillic = /[а-яА-ЯЁёҐґЄєІіЇї]/.test(value)
          return !hasCyrillic || 'English only'
        }
      }
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        if (!value) this.hasCyrillic = false
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  watch: {
    currentDayOff: {
      immediate: true,
      deep: true,
      handler () {
        this.validateDescription()
      }
    }
  },
  methods: {
    validateDescription () {
      if (this.currentDayOff && this.currentDayOff.EventDescription) {
        this.hasCyrillic = /[а-яА-ЯЁёҐґЄєІіЇї]/.test(this.currentDayOff.EventDescription)
      } else {
        this.hasCyrillic = false
      }
    },
    saveDayOff () {
      this.validateDescription()
      if (this.hasCyrillic) return
      this.disableSave = true
      const body = {
        EventDate: this.currentDayOff.EventDate,
        EventDescription: this.currentDayOff.EventDescription
      }

      if (this.addMode) {
        this.axios.post('/api/dayoff', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          const newItem = res.data[0] || res.data
          this.$emit('onAdded', newItem)
          this.finalize('Day off successfully added')
        }).catch(error => this.handleError(error))
      } else {
        this.axios.put(`/api/daysoff/${this.currentDayOff.ID}`, this.currentDayOff, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
          this.$emit('onUpdated', this.currentDayOff)
          this.finalize('Day off successfully updated')
        }).catch(error => this.handleError(error))
      }
    },
    finalize (msg) {
      this.disableSave = false
      this.show = false
      this.$store.dispatch('setSuccess', { successMsg: msg })
    },
    handleError (error) {
      this.disableSave = false
      const errorMsg = getApiErrorMessage(error)
      this.$store.dispatch('setError', { errorMsg })
    }
  }
}
</script>
